import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { ButtonComponent } from '@cue/ui';
import { cueClose, cueExclamation, cueNavigationCircle, cuePencil, IconComponent } from '@cue/ui/icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { translation } from '@cue/translations';

// http://localhost:4201/navigation?areaId=27&targetResourceId=503&wantOnlyBarrierFreePaths=true&startResourceId=490
@Component({
  selector: 'cue-no-barrier-free-path-found',
  imports: [ButtonComponent, IconComponent, TranslocoPipe],
  templateUrl: './no-barrier-free-path-found.component.html',
  styleUrl: './no-barrier-free-path-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoBarrierFreePathFoundComponent {
  ICONS = {
    cueClose,
    cueExclamation,
    cuePencil,
    cueNavigationCircle,
  };

  confirm = output();
  changeTarget = output();

  protected readonly translation = translation;
}
